
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/sommerguide",
      function () {
        return require("private-next-pages/[region]/[resort]/sommerguide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/sommerguide"])
      });
    }
  